import useDebounce from 'hooks/useDebounce';
import useSWR from 'swr';
import { IfDocSrchEfctReq, IfDocSrchRes } from '../models/IfDocSrch';

export const useApiDocSrch = (req: IfDocSrchEfctReq): { data: IfDocSrchRes[] | undefined; isLoading: boolean } => {
  const param = useDebounce(req, 500);

  const { data, isLoading } = useSWR<IfDocSrchRes[]>(
    param?.lang && ['/api/guest/zdata/ssqdoc/srchByTitle', { ...param, limit: 50 }]
  );

  return { data, isLoading };
};
